import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import TicketModal from "@/atomic/organisms/TicketModal";
import { Suspense } from "react";

export default function TicketView({
  tickets,
  openInvoice,
  isLoading,
  errorTickets,
  tryAgain,
  errorInvoice,
  goBack,
  toggleModal,
  isVisibleModal,
  generatePDF,
  invoice,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Recibos"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form bg-white">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Últimos recibos</h2>
            <div className="flex flex-col justify-center items-center mt-4">
              {tickets?.map((item, index) => (
                <div className="w-full" key={index}>
                  <div className="w-full flex flex-row justify-between items-center">
                    <p className="text-black text-base">{item?.date}</p>
                    <button type="button" onClick={() => openInvoice(item)}>
                      <p className="text-white bg-principal text-xs px-2 py-1 rounded-lg">Ver recibo</p>
                    </button>
                  </div>
                  <div className="w-full flex flex-row justify-between mt-1 items-center">
                    <p className="text-black text-xs">Valor</p>
                    <p className="text-black text-base font-bold">R$ {item?.price}</p>
                  </div>
                  <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                </div>
              ))}
            </div>
          </div>
        </article>
      </main>
      {errorTickets && <Suspense fallback={null}>
        <Modal 
          title="Atenção"
          message="Não foi possível trazer seus tickets."
          actionMessage="Tentar novamente"
          action={tryAgain}
          actionSecondMessage="Ok"
          actionSecond={toggleModal}
        />
      </Suspense>}
      {errorInvoice && <Suspense fallback={null}>
        <Modal 
          title="Atenção"
          message="Não foi possível baixar o PDF. Tente novamente mais tarde."
          actionMessage="Ok"
          action={toggleModal}
        />
      </Suspense>}
      {isVisibleModal && <Suspense fallback={null}>
        <TicketModal
          toggleModal={toggleModal}
          invoice={invoice}
          generatePDF={generatePDF}
        />
      </Suspense>}
      {isLoading &&  <Suspense fallback={null}>
        <Loading />
      </Suspense>}
    </div>
  );
}
